(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bellissimo-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellissimo-bundle')) {
    customElements.define('bellissimo-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.colour = this.querySelector('[data-bb-colour]');
        this.size = this.querySelector('[data-bb-size]');
        this.cards = Array.from(this.querySelectorAll('[data-bb-card]'));
        this.button = this.querySelector('[data-bb-submit]');
        this.fallback = this.querySelector('[data-bb-fallback]');
        this.fallback.hidden = true;
        this.fallback.querySelector('select').disabled = true;
        this.querySelectorAll('[data-bb-enhanced]').forEach(el => el.hidden = false);
        const selected = this.cards.find(card => card.querySelector('input').checked);
        this.pack = selected ? selected.dataset.pack : '2 bundles';
        if (selected) {
          this.colour.value = selected.dataset.colour;
          this.size.value = selected.dataset.size;
        }
        this.querySelectorAll('[data-piece-variant]').forEach(select => select.addEventListener('change', () => this.updatePiece(select.closest('[data-bb-piece]'), false)));
        this.addEventListener('change', event => {
          if (event.target.matches('[data-piece-variant]')) return;
          if (event.target.matches('input[type=radio]')) this.pack = event.target.closest('[data-bb-card]').dataset.pack;
          this.update();
        });
        this.update(false);
      }
      updatePiece(piece, matchSize) {
        const select = piece.querySelector('[data-piece-variant]');
        if (matchSize) {
          const match = Array.from(select.options).find(option => option.dataset.size === this.size.value.toLowerCase() || option.dataset.size === 'oxford pillowcase pair');
          if (match) select.value = match.value;
        }
        const option = select.selectedOptions[0];
        const button = piece.querySelector('[data-piece-buy]');
        const available = option && option.dataset.available === 'true';
        piece.querySelector('[data-piece-price]').textContent = option ? option.dataset.price : '';
        button.disabled = !available;
        button.textContent = available ? button.dataset.label : this.dataset.soldOut;
        piece.querySelectorAll('[data-piece-link]').forEach(link => {
          const url = new URL(link.href);
          if (option) url.searchParams.set('variant', option.value);
          link.href = url;
        });
      }
      update(updateUrl = true) {
        let chosen;
        this.cards.forEach(card => {
          const visible = card.dataset.colour === this.colour.value && card.dataset.size === this.size.value;
          const input = card.querySelector('input');
          card.hidden = !visible;
          input.disabled = !visible || input.dataset.available !== 'true';
          input.checked = visible && card.dataset.pack === this.pack;
          if (input.checked) chosen = input;
        });
        this.querySelectorAll('[data-bb-piece]').forEach(piece => { piece.hidden = piece.dataset.colour !== this.colour.value; this.updatePiece(piece, true); });
        this.querySelectorAll('[data-bb-image]').forEach(el => el.hidden = el.dataset.bbImage !== (this.colour.value === 'Grey' ? '1' : '0'));
        this.button.disabled = !chosen || chosen.disabled;
        this.button.textContent = chosen && !chosen.disabled ? chosen.dataset.cta : this.dataset.soldOut;
        this.querySelector('[data-bb-status]').textContent = '';
        if (chosen && updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', chosen.value);
          window.history.replaceState({}, '', url);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
